"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useProjectPageAuthorization = exports.useAdminPageAuthorization = exports.useUserPageAuthorization = void 0;
const auth_1 = require("./auth");
class AuthorizationError extends Error {
    constructor() {
        super("Unauthorized");
        this.name = "AuthorizationError";
    }
}
// ユーザが全員表示できるページの認証
const useUserPageAuthorization = () => {
    const { role, projectRoles, projectIds, loading, isAdmin } = (0, auth_1.useAdminAuthentication)();
    if (loading)
        return { loading };
    if (!isAdmin)
        return {}; // ページレベルでは処理せず、AdminLayoutで処理する（ページ単位のエラーメッセージは出さないため）
    const result = role || (projectRoles ? "project" : undefined);
    if (!result)
        throw new AuthorizationError();
    return {
        role: result,
        loading,
        projectIds: role ? undefined : projectIds,
    };
};
exports.useUserPageAuthorization = useUserPageAuthorization;
// マスターのみ表示できるページ（例：システム設定）の認証
const useAdminPageAuthorization = () => {
    const { role, loading, isAdmin } = (0, auth_1.useAdminAuthentication)();
    if (loading)
        return { loading };
    if (!isAdmin)
        return {}; // ページレベルでは処理せず、AdminLayoutで処理する（ページ単位のエラーメッセージは出さないため）
    const result = role;
    if (!result)
        throw new AuthorizationError();
    return {
        role: result,
        loading,
    };
};
exports.useAdminPageAuthorization = useAdminPageAuthorization;
const useProjectPageAuthorization = (projectId) => {
    const { role, projectRoles, projectIds, loading, isAdmin } = (0, auth_1.useAdminAuthentication)();
    if (loading)
        return { loading };
    if (!isAdmin)
        return {}; // ページレベルでは処理せず、AdminLayoutで処理する（ページ単位のエラーメッセージは出さないため）
    const result = role || (projectId && (projectRoles === null || projectRoles === void 0 ? void 0 : projectRoles[projectId]));
    if (!result)
        throw new AuthorizationError();
    return { projectRole: result, adminRole: role, loading, projectIds };
};
exports.useProjectPageAuthorization = useProjectPageAuthorization;
